<div class="landing-page__main">
  <form class="landing-page__form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <fieldset #wrapper formGroupName="wrapper" class="landing-page__fieldset">
      <div class="landing-page__menu">
          <div class="landing-page__type-selector-wrapper">
            <mat-button-toggle-group class="landing-page__type-selector" [(ngModel)]="query.type"
                                     formControlName="type" (change)="onQueryTypeChanged($event)">
              <mat-button-toggle [value]="SearchFormType.Airports">
                Airport Directory
              </mat-button-toggle>
              <mat-button-toggle [value]="SearchFormType.Activities">
                Explore Places to Fly
              </mat-button-toggle>
              <mat-button-toggle [value]="SearchFormType.AviationEvents">
                Find Events
              </mat-button-toggle>
              <mat-button-toggle [value]="SearchFormType.FuelPrice">
                Fuel Price Map
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
          <!-- <div class="landing-page__favorites-jump-bar">
            <div class="landing-page__button-group landing-page__type-selector">
              <a class="landing-page__favorites-link mat-button-toggle-spacing" (click)="onClickFavorite('airports')">
                <div class="mat-button-toggle-label-content-spacing">&nbsp;&nbsp;Favorite Airports&nbsp;&nbsp;</div>
              </a>
              <div class="landing-page__favorites-link mat-button-toggle-label-content-spacing mat-button-toggle-hidden">Explore Places to Fly</div>
              <a class="landing-page__favorites-link mat-button-toggle-spacing" (click)="onClickFavorite('events')">
                <div class="mat-button-toggle-label-content-spacing">Favorite Events</div>
              </a>
            </div>
            <a class="landing-page__advanced-search-hidden landing-page__link">Advanced Search</a>
          </div> -->
      </div>
      <div class="landing-page__form-wrapper">
        <div class="landing-page__form-main">
          <div class="landing-page__search-main">
            <div class="landing-page__field-container">
              <div class="landing-page__location-options">
                <label for="query" class="landing-page__field-label">{{ queryLabel }}:</label>
                <mat-radio-group *ngIf="query.type === SearchFormType.AviationEvents" formControlName="usOrInternational" class="landing-page__location-radio" aria-label="Select an option" (change)="clickUsorInternational($event)">
                  <mat-radio-button value="US" checked="true">United States</mat-radio-button>
                  <mat-radio-button value="International">International</mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="landing-page__field-wrapper">
                <mat-icon *ngIf="searchState === State.Empty || searchState === State.Content"
                          class="landing-page__field-icon">search</mat-icon>
                <mat-spinner *ngIf="searchState === State.Loading" [diameter]="16" class="landing-page__field-spinner"></mat-spinner>
                <mat-icon *ngIf="searchState === State.Error" class="landing-page__field-icon landing-page__field-icon--error">warning</mat-icon>
                <input #queryField id="query" type="search" [matAutocomplete]="acTrigger.auto"
                       formControlName="query" class="landing-page__field landing-page__query-field"
                       (focus)="onQueryFocus($event)" (blur)="onQueryBlur()" (keyup)="onQueryKeyPress()"
                       aria-label="Search" [placeholder]="searchPlaceholder" autocomplete="off" autocorrect="off">
              </div>
            </div>
            <div class="landing-page__submit-wrapper" [matTooltip]="validationReason">
              <button type="submit" mat-button [disabled]="!valid"
                      class="landing-page__submit-btn aopa-mat-btn aopa-mat-btn--lg aopa-mat-btn--filled">
                Search
              </button>
            </div>
          </div>
          <div *ngIf="searchErrorMsg" class="landing-page__error-msg">
            {{ searchErrorMsg }}
          </div>
          <div class="landing-page__filter-container">
            <div class="landing-page__tutorial-container">
              <button *ngIf="query.type === SearchFormType.Airports || query.type === SearchFormType.Activities" type="button" (click)="openVideoOverlay()" class="landing-page__tutorial-link">
                <mat-icon class="landing-page__tutorial-link-icon">play_circle_filled</mat-icon>
                <span class="landing-page__tutorial-link-text">Watch Overview Video</span>
              </button>
              <button *ngIf="query.type === SearchFormType.AviationEvents" type="button" mat-raised-button (click)="addEventFormClick()">Add Event</button>
              <a *ngIf="query.type === SearchFormType.FuelPrice" class="landing-page__tutorial-fuel-link-text" (click)="onClickFuelLearnMore()">Fuel Price Map Info</a>
            </div>
            <mat-tab-group #tabGroup disableRipple="true" (selectedTabChange)="onSelectTab($event)">
              <mat-tab #airportsTab *ngIf="query.type === SearchFormType.Airports">
                <ng-template mat-tab-label>
                  <div class="landing-page__tab">
                    <mat-icon class="landing-page__tab-icon">airplanemode_active</mat-icon>
                    <span class="landing-page__tab-text">Amenities</span>
                    <span *ngIf="numAirportFiltersSelected > 0" class="landing-page__filter-badge">
                      {{ numAirportFiltersSelected }}
                    </span>
                  </div>
                </ng-template>
                <app-airport-filter-list #airportFilters class="landing-page__filters"
                                         (filtersChange)="onAirportFiltersChanged()"
                                         [query]="query" [compact]="true"></app-airport-filter-list>
              </mat-tab>
              <mat-tab #activitiesTab *ngIf="query.type === SearchFormType.Activities">
                <ng-template mat-tab-label>
                  <div class="landing-page__tab">
                    <mat-icon class="landing-page__tab-icon">location_on</mat-icon>
                    <span class="landing-page__tab-text">Activities</span>
                  </div>
                </ng-template>
                <app-activity-filter-list #activityFilters class="landing-page__filters landing-page__filters--activities"
                                          [(selectedActivity)]="query.activity" [compact]="true">
                </app-activity-filter-list>
              </mat-tab>
              <mat-tab #aviationEventsTab *ngIf="query.type === SearchFormType.AviationEvents">
                <ng-template mat-tab-label>
                  <div class="landing-page__tab">
                    <mat-icon class="landing-page__tab-icon">events</mat-icon>
                    <span class="landing-page__tab-text">Event Filters</span>
                  </div>
                </ng-template>
                <app-event-filter-list #aviationEventFilters class="landing-page__filters"
                                       [query]="query" [compact]="true">
                </app-event-filter-list>
              </mat-tab>
              <mat-tab #fuelTab *ngIf="query.type === SearchFormType.FuelPrice">
                <ng-template mat-tab-label>
                  <div class="landing-page__tab">
                    <mat-icon class="landing-page__tab-icon">airplanemode_active</mat-icon>
                    <span class="landing-page__tab-text">Amenities</span>
                    <span *ngIf="numAirportFiltersSelected > 0" class="landing-page__filter-badge">
                      {{ numAirportFiltersSelected }}
                    </span>
                  </div>
                </ng-template>
                <app-fuel-filter-list #fuelFilters class="landing-page__filters"
                                      (filtersChange)="onFuelFiltersChanged()"
                                         [query]="query" [compact]="true"></app-fuel-filter-list>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    </fieldset>
    <div class="landing-page__main-footer">
      <div class="landing-page__img-caption">
        <!-- Alpine Airpark, Wyoming -->
      </div>
      <ul class="landing-page__footer-links">
        <li>
          <a class="landing-page__advanced-search landing-page__link" (click)="onClickAdvancedSearch()">Map Search</a>
        </li>
        <li>
          <a class="landing-page__link" [routerLink]="['/airports/state']">Browse by State</a>
        </li>
        <li>
          <a class="landing-page__link" href="https://www.aopa.org/travel/about-airports-terms" target="_blank">About</a>
        </li>
      </ul>
    </div>
  </form>
</div>
<!-- yes this is stupid, thank you Angular:
      https://github.com/angular/angular/issues/6595 -->
<div id="favorites"></div>
<app-favorites-list *ngIf="query.type !== 'events'"></app-favorites-list>
<app-favorite-events-list *ngIf="query.type === 'events'"></app-favorite-events-list>

<!-- Regular autocomplete for supported browsers -->
<app-autocomplete-trigger
  #acTrigger
  [query]="queryCtrl.value"
  [queryType]="queryType"
  [searchCtrl]="queryCtrl"
  [international]="isInternational"
  [currentSearchTab]="currentSearchTab"
  [(state)]="airportSearchState"
  (itemSelected)="onItemSelected($event)">
</app-autocomplete-trigger>

<!-- Alternative UI for iOS/Android -->
<app-autocomplete-overlay #acOverlay [queryType]="queryType" [international]="isInternational" [currentSearchTab]="currentSearchTab" (itemSelected)="onItemSelected($event)">
</app-autocomplete-overlay>

<!-- Overview Video Embed -->
<div *ngIf="videoOverlayActive" class="landing-page__video-overlay">
  <div class="landing-page__video-overlay-header">
    <mat-icon (click)="closeVideoOverlay()" class="landing-page__video-overlay-close">close</mat-icon>
  </div>
  <div class="landing-page__video-overlay-main">
    <div class="landing-page__video-overlay-spinner">
      <mat-spinner [diameter]="64"></mat-spinner>
    </div>
    <div style="position: relative; display: block; max-width: 860px;">
      <div style="padding-top: 56.2791%;">
        <iframe src="https://www.youtube.com/embed/s_M_4RIFv6s"
           allowfullscreen
           webkitallowfullscreen
           mozallowfullscreen
           style="position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px; width: 100%; height: 100%;">
        </iframe>
      </div>
    </div>
  </div>
</div>
